import Env from '@naruto/bgdapp/src/env';
import { ReduxConfig } from './types';

const getReduxConfigData = (env: typeof Env): ReduxConfig => ({
  middlewareConfig: {
    apiConfig: {
      host: env.config.APIUrl
    }
  },
  storeConfig: {}
});

export default getReduxConfigData;
